<template>
    <Interval
        :title="$t('nakshatra.name.' + nakshatra.number) + ' (' + nakshatra.lord + ') ' + nakshatraQuality"
        :description="nakshatra.number + $t('nakshatra.title') 
          + ' / ' + formatTime(nakshatra.start) + ' - ' + formatTime(nakshatra.end)
          + ' / ' + $t('nakshatra.type.' + nakshatra.type) + taraBalaType"
        :bg="'bg-'+nakshatra.lord.toLowerCase()" :favorable="nakshatra.favorable"
        :start="nakshatra.start" :length="nakshatra.length"
        :scale="scale" :zero="zero" :visibleLeft="visibleLeft"
    />
</template>

<script>
import Interval from '@/components/panchanga/Interval'
import { mapGetters } from 'vuex'
import { TimeFormatMixin } from '@/components/visual/TimeFormatMixin'
export default {
  props: ['nakshatra', 'scale', 'zero', 'visibleLeft'],
  components: { Interval },
  mixins: [TimeFormatMixin],
  computed: {
    nakshatraQuality() {
      var qualitySet = this.nakshatraPersonalQuality(this.nakshatra.number)
      if (qualitySet === null)
        return ''

      return (qualitySet.quality == 1 ? '<span class="auspicious">' : '<span class="nonauspicious">') 
        + this.$t('nakshatra.quality.' + qualitySet.quality)
        + '</span>'
    },
    taraBalaType() {
      var qualitySet = this.nakshatraPersonalQuality(this.nakshatra.number)
      if (qualitySet === null)
        return ''
      return ' / ' + this.$t('nakshatra.tarabala.' + qualitySet.type) + '-' + qualitySet.paryaya
    },
    ...mapGetters('predictions', ['nakshatraPersonalQuality']),
  }
}
</script>

<i18n locale="ru" lang="yaml">
  nakshatra:
    title: "-я накшатра"
    name:
      1: "Ашвини"
      2: "Бхарани"
      3: "Криттика"
      4: "Рохини"
      5: "Мригашира"
      6: "Ардра"
      7: "Пунарвасу"
      8: "Пушья"
      9: "Ашлеша"
      10: "Магха"
      11: "Пурва-Пхалгуни"
      12: "Уттара-Пхалгуни"
      13: "Хаста"
      14: "Читра"
      15: "Свати"
      16: "Вишакха"
      17: "Анурадха"
      18: "Джиештха"
      19: "Мула"
      20: "Пурва-Ашадха"
      21: "Уттара-Ашадха"
      22: "Шравана"
      23: "Дхаништха"
      24: "Шатабхиша"
      25: "Пурва-Бхадрапада"
      26: "Уттара-Бхадрапада"
      27: "Ревати"
    type:
      sthira: "Неподвижная"
      chara: "Подвижная"
      ugra: "Страшная"
      kshipra: "Легкая"
      mridu: "Мягкая"
      tikshna: "Резкая"
      misra: "Смешанная"
    quality:
      1: "Благоприятная"
      -1: "Неблагоприятная"
    tarabala:
      janma: "Джанма"
      sampat: "Сампат"
      vipat: "Випат"
      kshema: "Кшема"
      pratyak: "Пратьяк"
      sadhana: "Садхана"
      vadha: "Вадха"
      mitra: "Митра"
      paramamitra: "Парамамитра"
</i18n>

<i18n locale="en" lang="yaml">
  nakshatra:
    title: " nakshatra"
    type:
      sthira: "Fixed"
      chara: "Movable"
      ugra: "Fierce"
      kshipra: "Swift"
      mridu: "Tender"
      tikshna: "Sharp"
      misra: "Mixed"
    name:
      1: "Ashvini"
      2: "Bharani"
      3: "Krittika"
      4: "Rohini"
      5: "Mrigashira"
      6: "Ardra"
      7: "Punarvasu"
      8: "Pushya"
      9: "Ashlesha"
      10: "Magha"
      11: "Purva-Phalguni"
      12: "Uttara-Phalguni"
      13: "Hasta"
      14: "Chitra"
      15: "Svati"
      16: "Vishakha"
      17: "Anuradha"
      18: "Jyeshtha"
      19: "Mula"
      20: "Purva-Ashadha"
      21: "Utara-Ashadha"
      22: "Shravana"
      23: "Dhanishtha"
      24: "Shatabhisha"
      25: "Purva-Bhadrapada"
      26: "Uttara-Bhadrapada"
      27: "Revati"
    quality:
      1: "Auspicious"
      -1: "Non-auspicious"
    tarabala:
      janma: "Janma"
      sampat: "Sampat"
      vipat: "Vipat"
      kshema: "Kshema"
      pratyak: "Pratyak"
      sadhana: "Sadhana"
      vadha: "Vadha"
      mitra: "Mitra"
      paramamitra: "Paramamitra"
</i18n>
